export const dacumServices = {
  DACUM: {
    COMPETENCY_MANAGEMENT: {
      LIST: '/competency-management/get-list',
      PAGINATED_LIST: '/competency-management/list',
      ADD: '/competency-management/add',
      UPDATE: '/competency-management/update',
      DELETE: '/competency-management/delete',
      DETAIL: '/competency-management/detail/{id}',
      LIST_COMPETENCY_NAME: '/dacum/list-competency-name'
    },
    SCHOOL_MANAGEMENT: {
      LIST: '/school-competency/get-list',
      ADD: '/school-competency/add',
      UPDATE: '/school-competency/update',
      DELETE: '/school-competency/delete',
      DETAIL: '/school-competency/detail'
    },
    SCHOOL_JOB_FAMILY: {
      LIST: '/school-job-family/get-list',
      ADD: '/school-job-family/add',
      UPDATE: '/school-job-family/update',
      DELETE: '/school-job-family/delete',
      DETAIL: '/school-job-family/detail'
    },
    MODULE_MANAGEMENT: {
      LIST: '/competency-modules/get-list',
      ADD: '/competency-modules/add',
      UPDATE: '/competency-modules/update',
      DELETE: '/competency-modules/delete',
      DETAIL: '/competency-modules/detail',
      JOB_FAMILY_LIST: '/competency-module-job-family/by-module',
      JOB_FAMILY_ADD: '/competency-module-job-family/add',
      JOB_FAMILY_DELETE: '/competency-module-job-family/delete'
    },
    REVIEW_MASTERPLAN: {
      LIST: '/dacum/competency-positions',
      KEYACTION_LIST: '/dacum/key-actions',
      DETAIL: '/dacum/competency-positions/{id}'
    },
    MASTERPLAN: {
      ADD: '/dacum/masterplan/add',
      LIST: '/dacum/masterplan/jobfamily-year',
      LIST_BY_GROUP: '/dacum/masterplan/jobfamily-group-year',
      DETAIL: '/dacum/masterplan/detail',
      DETAIL_BY_GROUP: '/dacum/masterplan/detail-by-group',
      OVERVIEW: '/dacum/masterplan/overview',
      JOBBAND_OVERVIEW: '/dacum/masterplan/overview/jobband',
      COURSE_OVERVIEW: '/dacum/masterplan/overview/course',
      BRANCHED_OVERVIEW: '/dacum/masterplan/overview/branched-masterplan',
      UPDATE: '/dacum/masterplan/update',
      DELETE: (id: string) => `/dacum/masterplan/delete/${id}`,
      APPROVE: (id: string) => `/dacum/masterplan/approve/${id}`,
      REJECT: '/dacum/masterplan/reject'
    },
    CURRICULUM_MAPPING: {
      LIST: '/dacum/curriculum-mapping'
    },
    REPORT: {
      LIST: '/lcms/report',
      DETAIL: '/lcms/report/{id}'
    }
  }
};
